// extracted by mini-css-extract-plugin
export var disabled = "_87-3";
export var growableInput = "_87-0";
export var tagContainer = "_87-2";
export var textInput = "_87-1";